import { render, staticRenderFns } from "./Roles.vue?vue&type=template&id=a7adf548&scoped=true&"
import script from "./Roles.vue?vue&type=script&lang=js&"
export * from "./Roles.vue?vue&type=script&lang=js&"
import style0 from "./Roles.vue?vue&type=style&index=0&id=a7adf548&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7adf548",
  null
  
)

component.options.__file = "Roles.vue"
export default component.exports